import EditIcon from "../../../assets/Edit.svg";
import DeleteIcon from "../../../assets/Delete.svg";

export default function HangerTable({ hangersData = [], onEdit, onDelete }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        padding: "20px",
        border: "1px solid #6B7280",
        borderRadius: "20px",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "minmax(120px, 1.5fr) minmax(80px, 1fr) minmax(80px, 0.8fr) minmax(100px, 1fr) minmax(180px, 2fr) minmax(150px, 1.8fr) minmax(120px, 1.2fr) minmax(80px, 0.8fr)",
          gap: "16px",
          padding: "13.5px 0 15px 0",
          borderBottom: "1px solid #D1D5DB",
        }}
      >
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Material
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Notes
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Insulated
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Up to Size
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Hanger
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Shield/Accessory
        </p>
        <p
          style={{
            color: "#111827",
            fontSize: "14px",
            fontFamily: "Inter",
            textAlign: "left",
            fontWeight: 600,
            lineHeight: "20px",
          }}
        >
          Action
        </p>
      </div>

      {hangersData.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 0",
            color: "#6B7280",
            fontSize: "14px",
            fontFamily: "Inter",
          }}
        >
          No hanger data available
        </div>
      ) : (
        hangersData.map((hanger, index) => (
          <div
            key={hanger.id}
            style={{
              display: "grid",
              gridTemplateColumns:
                "minmax(120px, 1.5fr) minmax(80px, 1fr) minmax(80px, 0.8fr) minmax(100px, 1fr) minmax(180px, 2fr) minmax(150px, 1.8fr) minmax(120px, 1.2fr) minmax(80px, 0.8fr)",
              gap: "16px",
              padding: "13.5px 0",
              borderTop: index > 0 ? "1px solid #E5E7EB" : "none",
            }}
          >
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {hanger.material || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {hanger.notes || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {hanger.insulation ? "Yes" : "No"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
              }}
            >
              {hanger.max_size || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {hanger.hanger_product || "—"}
            </p>
            <p
              style={{
                color: "#6B7280",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordBreak: "break-word",
              }}
            >
              {hanger.shield_product || "—"}
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <img
                src={EditIcon}
                alt="Edit"
                style={{ cursor: "pointer" }}
                onClick={() => onEdit && onEdit(hanger)}
              />
              <img
                src={DeleteIcon}
                alt="Delete"
                style={{ cursor: "pointer" }}
                onClick={() => onDelete && onDelete(hanger)}
              />
            </div>
          </div>
        ))
      )}
    </div>
  );
}
